import React from "react";
import { DropzoneArea } from "material-ui-dropzone";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Trad } from "../../../components/";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    container: {
        marginTop: spacing(4),
        minHeight: 120
    },
    icon: { color: palette.grey[300] }
}));

interface IDropzoneProps {
    OnFileDrop: (files: File[]) => void;
}

export const _Dropzone: React.FC<IDropzoneProps> = ({ OnFileDrop }) => {
    const classes = useStyles();

    return (
        <DropzoneArea
            filesLimit={1}
            acceptedFiles={["image/*"]}
            dropzoneText={Trad.Trad("CaricaDocumento")}
            onChange={OnFileDrop}
            dropzoneClass={classes.container}
            getFileAddedMessage={(fileName: string) => Trad.TradParam("File {1-S} was successfully added.", [fileName])}
            getFileRemovedMessage={(fileName: string) => Trad.TradParam("File {1-S} was rejected.", [fileName])}
            classes={{ icon: classes.icon }}
            showFileNamesInPreview
            useChipsForPreview
        />
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/Dropzone.tsx